import { useIntl } from "react-intl";
import { useCallback, useState, useContext } from "react";
import { NotificationsContext } from "@ui-components/Notifications";
import CountryContext from "../../../../CountryContext";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

export const useImageUploader = (worksite_id, des_type) => {
  const intl = useIntl();

  const { push } = useContext(NotificationsContext);
  const { country } = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country.code);
  const [uploadingImage, setUploadingImage] = useState(false);

  const onImageUploaded = useCallback(
    async (url) => {
      setUploadingImage(true);
      try {
        // upload image
        const image = await countryApiRequest.post("/images", {
          val_type: "worksite_task_map",
          id_worksite: worksite_id,
          id_worksite_activity: null,
          val_url: url,
          val_description: intl.formatMessage({ id: "new_task_map" }),
          r_perm: ["public"],
          w_perm: ["public"],
        });
        // upload task map
        const taskMap = await countryApiRequest.post("/worksites_tasks_maps", {
          id_worksite: worksite_id,
          id_image: image.id,
          des_type: des_type,
          r_perm: ["public"],
          w_perm: ["public"],
        });

        const current = { ...taskMap, image };
        push({
          type: "success",
          title: intl.formatMessage({ id: "taskmap_created_successfully" }),
        });

        return current;
      } catch (e) {
        push({
          type: "error",
          title: intl.formatMessage({ id: "server_error" }),
        });
        throw e;
      } finally {
        setUploadingImage(false);
      }
    },
    [countryApiRequest, des_type, intl, push, worksite_id]
  );

  const saveCurrentMapName = useCallback(
    async (image, val_description) => {
      try {
        const updated = await countryApiRequest.put(`/images/${image.id}`, {
          ...image,
          val_description,
        });

        push({
          type: "success",
          title: intl.formatMessage({ id: "name_successfully_modified" }),
        });
        return updated;
      } catch (e) {
        push({
          type: "error",
          title: intl.formatMessage({ id: "server_error" }),
        });
        throw e;
      }
    },
    [countryApiRequest, intl, push]
  );

  const deleteMap = async (selected) => {
    try {
      await countryApiRequest.delete(`/images/${selected.image.id}`); // this deletes the task map entity on cascade

      push({
        type: "info",
        title: intl.formatMessage({ id: "taskmap_deleted_successfully" }),
      });
      return true;
    } catch (e) {
      push({
        type: "error",
        title: intl.formatMessage({ id: "server_error" }),
      });
      throw e;
    }
  };

  return {
    uploadingImage,
    setUploadingImage,
    onImageUploaded,
    saveCurrentMapName,
    deleteMap,
  };
};

export default useImageUploader;
